module.exports = require("core-js/library/fn/promise");


//////////////////
// WEBPACK FOOTER
// external "core-js/library/fn/promise"
// module id = 14
// module chunks = 0